var printnplayTileTemplate = require('./printnplay-search-results.handlebars');
var { getUrlParameterByName } = require('./../../../shared/scripts/UrlParameterHelper');
var printnplayService = new printnplayService();
var Pager = require('./../../../shared/components/pager/pagerService');
var printnplayPager = new Pager();

$(function () {

    if (!$('#printnplay-search').length) return;

    var $modalBtnApplyFilter = $('#printnplay-search-filter-modal #modal-apply-filters'),
        $btnApplyFilter = $('#printnplay-search #apply-filters'),
        $allPriceFiltersOption = $('#printnplay-search #price-filters input[name="allPriceFilters"]').parent(),
        $priceFilterOptions = $('#printnplay-search #price-filters input[name="priceFilter"]').parent(),
        $modalPriceFilterOptions = $('#printnplay-search-filter-modal #modal-price-filters input[name="priceFilter"]').parent(),
        $modalAllPriceFiltersOption = $('#printnplay-search-filter-modal #modal-price-filters input[name="allPriceFilters"]').parent(),
        $modal = $('#printnplay-search-filter-modal');

    //Initialize
    let requestedPageSize = parseInt($('#printnplay-pager-page-size').val());
    (Number.isInteger(requestedPageSize))
        ? printnplayPager.setPageSize(requestedPageSize)
        : printnplayPager.setPageSize(printnplayService.options.pageSize);
    printnplayPager.setCurrentPage(0);
    printnplayService.options.filters = getPrintnplayFilterValues();

    //Try to set initial filter values from query string values
    setInitialFiltersFromUrl();

    //GET
    getPrintnplay();

    //Events
    $modalBtnApplyFilter.on('click', function (e) {
        $modal.modal('hide');
        printnplayService.options.page = 0;
        printnplayService.options.filters = getPrintnplayFilterValues(true);
        getPrintnplay(0); //WTS 5/13/21 When the apply filter button is clicked, always default back to page 1
        syncPrintnplayFilterValues();
        updateAppliedPrintnplayFilterDisplay();
    });

    $btnApplyFilter.on('click', function (e) {
        printnplayService.options.page = 0;
        printnplayService.options.filters = getPrintnplayFilterValues();
        getPrintnplay(0); //WTS 5/13/21 When the apply filter button is clicked, always default back to page 1
        syncPrintnplayFilterValues();
        updateAppliedPrintnplayFilterDisplay();
    });

    $allPriceFiltersOption.on('click', function (e) {
        handlePrintnplayPriceFilterClick(e);
    });
    $modalAllPriceFiltersOption.on('click', function (e) {
        handlePrintnplayModalPriceFilterClick(e);
    });
    $priceFilterOptions.on('click', function (e) {
        handlePrintnplayPriceFilterClick(e);
    });
    $modalPriceFilterOptions.on('click', function (e) {
        handlePrintnplayModalPriceFilterClick(e);
    });

    $modal.on('show.bs.modal', function () {
        printnplayService.options.filters = getPrintnplayFilterValues();
        syncPrintnplayFilterValues();
    });
    $modal.on('hide.bs.modal', function () {
        printnplayService.options.filters = getPrintnplayFilterValues(true);
        syncPrintnplayFilterValues();
    });

});

function handlePrintnplayPriceFilterClick(e) {
    var targetName = $(e.target).find('input')[0].name,
        targetValue = $(e.target).find('input').val(),
        allPrices = $('#price-filters input[name="allPriceFilters"]'),
        allPricesIsChecked = $('#price-filters input[name="allPriceFilters"]:checked').parent().hasClass('active'),
        priceFilters = $('#price-filters input[name="priceFilter"]:checked'),
        currentlySelectedFilters = getPrintnplayFilterValues();

    //allprices is clicked and is currently NOT 'active'
    //does nothing if allprices is already 'active'
    if (targetName === "allPriceFilters") {

        if (allPricesIsChecked) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        //toggle allprices will be set to 'active'
        //uncheck all others that are checked
        priceFilters.parent().button('toggle');
    }

    //any priceFilter is clicked and allPrices is currently 'active'
    //does nothing if allprices is NOT 'active'
    if (targetName === "priceFilter") {
        //set allprices to NOT 'active'
        if (allPricesIsChecked) {
            allPrices.parent().button('toggle');
            return;
        }

        var index = currentlySelectedFilters.prices.indexOf(targetValue);
        if (index > -1) {
            currentlySelectedFilters.prices.splice(index, 1);
            if (!currentlySelectedFilters.prices.length) {
                allPrices.parent().button('toggle');
            }
        }
    }

};
function handlePrintnplayModalPriceFilterClick(e) {
    var targetName = $(e.target).find('input')[0].name,
        targetValue = $(e.target).find('input').val(),
        allPrices = $('#modal-price-filters input[name="allPriceFilters"]'),
        allPricesIsChecked = $('#modal-price-filters input[name="allPriceFilters"]:checked').parent().hasClass('active'),
        priceFilters = $('#modal-price-filters input[name="priceFilter"]:checked'),
        currentlySelectedFilters = getPrintnplayFilterValues(true);

    //allprices is clicked and is currently NOT 'active'
    //does nothing if allprices is already 'active'
    if (targetName === "allPriceFilters") {

        if (allPricesIsChecked) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        //toggle allprices will be set to 'active'
        //uncheck all others that are checked
        priceFilters.parent().button('toggle');
    }

    //any priceFilter is clicked and allPrices is currently 'active'
    //does nothing if allprices is NOT 'active'
    if (targetName === "priceFilter") {
        //set allprices to NOT 'active'
        if (allPricesIsChecked) {
            allPrices.parent().button('toggle');
            return;
        }

        var index = currentlySelectedFilters.prices.indexOf(targetValue);
        if (index > -1) {
            currentlySelectedFilters.prices.splice(index, 1);
            if (!currentlySelectedFilters.prices.length) {
                allPrices.parent().button('toggle');
            }
        }
    }

};

function getPrintnplay(page) {
    printnplayService.options.pageSize = printnplayPager.getPageSize();
    if (page == undefined)
    {
    	printnplayService.options.page = printnplayPager.getCurrentPage();
    }
    else 
    {
    	printnplayService.options.page = page;
    }
     

    unbindPrintnplayTileEvents();

    $.ajax({
        url: '/api/v1/printnplay',
        type: 'POST',
        data: printnplayService.options,
        dataType: 'json'
    })
        .done(function (data) {
            var html = printnplayTileTemplate({ printnplay: data.data });
            $('#printnplay-tiles').html(html);

            bindPrintnplayTileEvents();
            printnplayPager.update("printnplay-pager", "#printnplay-pager-container", getPrintnplay, data.totalPages, data.currentPage);
        });
}

function getPrintnplayFilterValues(fromModal) {
    var $priceContainer,
        $categoryContainer;

    if (fromModal) {
        $priceContainer = $('#modal-price-filters');
        $categoryContainer = $('#modal-category-filter');
    }
    else {
        $priceContainer = $('#price-filters');
        $categoryContainer = $('#category-filter');
    }

    return {
        prices: getPrices($priceContainer),
        categories: getCategories($categoryContainer)
    };

    function getPrices($container) {
        return $container
            .find(".btn.active input:checkbox:not([name='allPriceFilters']):checked")
            .map(function () { return this.value; })
            .get();
    }

    function getCategories($container) {
        return $container
            .find(".btn.active input[type=radio]")
            .map(function () { return this.value; })
            .get()
    }
}

function syncPrintnplayFilterValues() {
    syncPrintnplayCategoryFilters();
    syncPrintnplayPriceFilters();
}
function syncPrintnplayCategoryFilters() {
    printnplayService.options.filters.categories.forEach(function (x) {
        $('#printnplay-search #category-filter input[type=radio]#' + x)
            .parent()
            .button('toggle');
        $('#printnplay-search-filter-modal #modal-category-filter input[type=radio]#' + x)
            .parent()
            .button('toggle');
    });
}

function syncPrintnplayPriceFilters() {
    //Reset all selected (checkbox) filters
    $('#printnplay-search #price-filters .btn').removeClass('active focus');
    $('#printnplay-search-filter-modal #modal-price-filters .btn').removeClass('active focus');

    if (!printnplayService.options.filters.prices.length) {
        var $allPrices = $('#price-filters input[name="allPriceFilters"]').parent();
        var $modalAllPrices = $('#modal-price-filters input[name="allPriceFilters"]').parent();

        if (!$allPrices.hasClass('active')) {
            $allPrices.button('toggle');
        }
        if (!$modalAllPrices.hasClass('active')) {
            $modalAllPrices.button('toggle');
        }
    }

    printnplayService.options.filters.prices.forEach(function (x) {
        $('#printnplay-search #price-filters input[type=checkbox][value="' + x + '"]')
            .parent()
            .button('toggle');
        $('#printnplay-search-filter-modal #modal-price-filters input[type=checkbox][value="' + x + '"]')
            .parent()
            .button('toggle');
    });
}

function bindPrintnplayTileEvents() {
    var $tiles = $('.printnplay-tile');

    //Set initial tile-left background
    $tiles.each(function () {
        var $tile = $(this);
        var imageUrl = $tile.data('image-url');
        if (imageUrl) {
           hoverBackground($tile, imageUrl);
        }
    });

    $tiles.on('mouseenter', function () {
        var $tile = $(this);
        var imageUrl = $tile.data('image-url');
        if (imageUrl) {
            initialBackground($tile, imageUrl);
        }
    });
    $tiles.on('mouseleave', function () {
        var $tile = $(this);
        var imageUrl = $tile.data('image-url');
        if (imageUrl) {
            hoverBackground($tile, imageUrl);
        }
    });

    function initialBackground($tile, imageUrl) {
        var $tileLeft = $tile.find('.tile-left');
        $tileLeft.css('background', '');
        var defaultBackgroundColor = $tileLeft.css('background-color');
        $tileLeft.css({
            "background": "linear-gradient(0deg, " + defaultBackgroundColor + ", " + defaultBackgroundColor + "), url(" + imageUrl + ")",
            "background-size": "cover",
            "background-position": "center"
        });
        $tileLeft.children().css("color", "");
    }
    function hoverBackground($tile, imageUrl) {
        var $tileLeft = $tile.find('.tile-left');
        $tileLeft.css({
            "background": "linear-gradient(0deg, transparent, transparent), url(" + imageUrl + ")",
            "background-size": "cover",
            "background-position": "center"
        });
        $tileLeft.children().css("color", "transparent");
    }
}

function unbindPrintnplayTileEvents() {
    $(".printnplay-tile").off("mouseenter mouseleave");
}

function updateAppliedPrintnplayFilterDisplay() {
    var filterCount = [].concat(printnplayService.options.filters.categories, printnplayService.options.filters.prices).length;
    $('.applied-filters-display').text(filterCount);
}

function setInitialFiltersFromUrl() {
    var qsCategory = getUrlParameterByName('category', window.location.search);
    var qsPrice = getUrlParameterByName('price', window.location.search, true);

    if (!qsCategory && !qsPrice)
        return;

    if (qsCategory) {
        printnplayService.options.filters.categories = [];
        printnplayService.options.filters.categories.push(qsCategory);
    }

    if (qsPrice) {
        if (qsPrice.length > 1) {
            qsPrice.forEach((x) => {
                printnplayService.options.filters.prices.push(x);
            });
        } else {
            printnplayService.options.filters.prices.push(qsPrice);
        }
    }
    syncPrintnplayFilterValues();
}

function printnplayService(options) {

    var printnplaySearchDefaultOptions = {
        page: 0,
        totalPages: 0,
        pageSize: 10,
        filters: {
            prices: [],
            categories: []
        }
    };

    this.options = $.extend(true, printnplaySearchDefaultOptions, options);
}


// WEBPACK FOOTER //
// ./features/printnplay/printnplay-search/printnplay-search.js